<template>
  <div class="history-page-container">
    <header class="history-header">
      <div class="header-content">
        <div class="title-section">
          <h2 class="page-title">观看历史</h2>
          <span class="history-count">共 {{ totalSize }} 条记录</span>
        </div>
        <div class="action-section">
          <el-button
            type="danger"
            plain
            size="mini"
            class="clear-btn"
            icon="el-icon-delete"
            @click="removeAll"
          >
            <span class="hidden-xs-only">清空记录</span>
          </el-button>
        </div>
      </div>
    </header>

    <main class="history-main">
      <div v-if="visitList.length !== 0" class="timeline-wrapper">
        <el-timeline class="mobile-timeline">
          <el-timeline-item
            v-for="(record, index) in visitList"
            :key="index"
            :timestamp="record.createAt"
            placement="top"
            color="#409EFF"
          >
            <div class="history-item-card">
              <div class="card-content">
                <history-video-card :video="record" />
              </div>

              <div class="card-actions">
                <el-button
                  type="text"
                  icon="el-icon-close"
                  class="delete-btn"
                  @click.stop="removeHistory(record.videoId)"
                >
                  <span class="hidden-sm-and-up">移除</span>
                </el-button>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>

        <div class="load-more-section">
          <el-button
            v-if="hasMore"
            type="primary"
            plain
            round
            size="small"
            :loading="loading"
            @click="loadMore"
          >
            加载更多
          </el-button>
          <p v-else class="no-more-tips">已经到底了 ~</p>
        </div>
      </div>

      <div v-else class="empty-wrapper">
        <el-empty description="没有历史记录" :image-size="120">
          <el-button type="primary" size="small" @click="$router.push('/')">去逛逛</el-button>
        </el-empty>
      </div>
    </main>

    <el-backtop target=".admin-main" :bottom="20" :right="20" />
  </div>
</template>

<script>
import HistoryVideoCard from '@/components/card/HistoryVideoCard.vue'
import { getVisitRecord } from '@/api/vod'

export default {
  name: 'MyHistory',
  components: { HistoryVideoCard },
  data() {
    return {
      currentUser: null,
      totalSize: 0,
      nextId: 0,
      visitList: [],
      hasMore: true,
      loading: false
    }
  },
  created() {
    document.title = '历史记录'
    this.currentUser = this.$store.state.userInfo
    if (this.currentUser === null) {
      this.$message.warning('请先登入')
      return
    }

    this.fetchData(0)
  },
  methods: {
    fetchData(id) {
      this.loading = true
      getVisitRecord(id).then(res => {
        if (res.code === 0) {
          const { list, totalSize, nextId } = res.data
          if (!list || list.length === 0) {
            this.hasMore = false
            return
          }
          this.visitList = [...this.visitList, ...list]
          this.totalSize = totalSize
          this.nextId = nextId
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadMore() {
      if (!this.loading && this.hasMore) {
        this.fetchData(this.nextId)
      }
    },
    removeHistory(videoId) {
      this.$confirm('确认移除？', '提示', {
        type: 'warning',
        confirmButtonClass: 'el-button--danger'
      }).then(() => {
        this.$message.success('已移除')
      }).catch(() => {})
    },
    removeAll() {
      this.$confirm('确定清空？', '警告', {
        type: 'error'
      }).then(() => {
        this.visitList = []
        this.totalSize = 0
        this.$message.success('已清空')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.history-page-container {
  min-height: 100%;
  position: relative;
}

/* 顶部固定 Header */
.history-header {
  background: #fff;
  padding: 16px 24px;
  position: sticky;
  top: -24px;
  margin: -24px -24px 0 -24px;
  z-index: 100;
  border-bottom: 1px solid #e6e6e6;
}

.header-content {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.history-count {
  font-size: 12px;
  color: #9499a0;
}

/* 列表区 */
.history-main {
  max-width: 1100px;
  margin: 20px auto 0;
}

.timeline-wrapper {
  background: #fff;
  padding: 30px 20px;
}

.history-item-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s;
}

.history-item-card:hover {
  background-color: #f6f7f8;
}

.card-content {
  flex: 1;
}

.card-actions {
  margin-left: 15px;
}

/* 移动端适配核心代码 */
@media screen and (max-width: 768px) {
  /* 调整 Header 间距 */
  .history-header {
    padding: 12px 16px;
    top: -24px;
  }

  .history-main {
    margin: 0; /* 移动端取消上边距 */
  }

  /* 核心：减少时间轴左边距，给卡片腾位置 */
  ::v-deep .el-timeline {
    padding-left: 10px;
  }

  .timeline-wrapper {
    padding: 15px 10px;
    border-radius: 0; /* 撑满屏幕 */
  }

  /* 调整卡片布局为垂直，删除按钮放在底部或调整边距 */
  .history-item-card {
    flex-direction: column;
    align-items: flex-end; /* 删除按钮靠右 */
    padding: 0;
  }

  .card-content {
    width: 100%;
  }

  .card-actions {
    margin: 5px 0 0 0;
    opacity: 1; /* 移动端不依赖 hover，直接显示 */
  }

  .delete-btn {
    padding: 5px;
    background: #fdf2f2;
    border-radius: 4px;
    font-size: 12px;
    color: #f56c6c;
  }
}

/* 深度样式 */
::v-deep .el-timeline-item__timestamp {
  font-weight: bold;
  color: #1f1f1f;
}

.load-more-section {
  text-align: center;
  padding: 20px 0;
}

.no-more-tips {
  color: #bdc1c6;
  font-size: 13px;
}

/* Element 自带响应式类名辅助 */
.hidden-xs-only {
  @media (max-width: 767px) { display: none !important; }
}
.hidden-sm-and-up {
  @media (min-width: 768px) { display: none !important; }
}
</style>
